module.exports = __webpack_public_path__ + "img/menu2.e7ff65d3.png";